// @flow

import React, { Component } from 'react';
import {Icon} from 'react-fa';

import TreeUser from './TreeUser.jsx';

import {mk_title, no_rclick} from './utils.js';

import type {T_Item} from './types.js';

import './css/TreeUserItem.css';


type T_TreeUserItemProps = {
  node     : T_Item,
  num      : number,
  tree_user: TreeUser
};



export default class TreeUserItem extends Component<T_TreeUserItemProps> {
  static first = null;
  
  open: () => void;
  add : () => void;
  
  
  
  constructor(props: T_TreeUserItemProps) {
    super(props);
    
    if (props.num === 0) {
      TreeUserItem.first = this;
    }
    
    this.open = this.open.bind(this);
    this.add  = this.add.bind(this);
  }
  
  
  
  open(): void {
    const {tree_user} = this.props;
    
    if (tree_user.can_open(this.props.node.Path)) {
      tree_user.open_dir(this.props.node);
    }
  }
  
  
  
  add(): void {
    const {tree_user} = this.props;
    
    if (tree_user.can_open(this.props.node.Path)) {
      tree_user.add_dir(this.props.node);
    }
  }
  
  
  
  render() {
    return (
      <p className='tree_user_item'>
        <Icon name='arrow-left' className='icon_green' onClick={this.add} onContextMenu={no_rclick} />
        
        <a onClick={this.open} onContextMenu={no_rclick}>
          {mk_title(this.props.node.label)}
        </a>
      </p>
    );
  }
}



// WEBPACK FOOTER //
// ./src/TreeUserItem.jsx